import React from 'react';
import { AuthContextProvider } from '@/src/features/app/store/auth/Provider';
import { Router } from '@/src/features/app/router/Router';
import { NotificationsContextProvider } from '@/src/features/app/store/notifications/Provider';
import { Notifications } from '@/src/features/app/features/notifications/Notifications';
import { SessionContextProvider } from '@/src/features/app/store/session/Provider';
import { DimensionContextProvider, PositionerContextProvider } from '@skozub/react-components';

import '../../i18n';
import './App.sass';

export function App() {
  return (
    <DimensionContextProvider>
      <AuthContextProvider>
        <PositionerContextProvider>
          <NotificationsContextProvider>
            <SessionContextProvider>
              <Router />
              <Notifications />
            </SessionContextProvider>
          </NotificationsContextProvider>
        </PositionerContextProvider>
      </AuthContextProvider>
    </DimensionContextProvider>
  );
}
